/* PPD config confirm: cross-body preview before adding to the bag.
 *
 * Cross-body setups combine design, hardware, and strap choices, so the
 * add-to-bag submit pauses in a native <dialog> showing the exact
 * configuration (design photo, per-option rows, live price). Confirming
 * submits the real product form once; cancelling returns focus to the
 * add button. Without JS the form submits normally — the dialog never
 * opens and nothing intercepts the gesture.
 */
(function () {
  function fieldRows(scope) {
    var rows = [];
    scope.querySelectorAll('.variant-field').forEach(function (field) {
      var labelEl = field.querySelector('.variant-field__label');
      var checked = field.querySelector('.variant-chip[aria-checked="true"]');
      if (!labelEl || !checked) return;
      var label = labelEl.cloneNode(true);
      var count = label.querySelector('.variant-field__count');
      if (count) count.remove();
      var name = label.textContent.trim().replace(/\s+/g, ' ');
      var value = checked.getAttribute('data-variant') || checked.textContent.trim();
      if (name && value) rows.push({ name: name, value: value });
    });
    return rows;
  }

  function activeGalleryImage() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return null;
    var figure = gallery.querySelector('.ppd-product-media.is-active') || gallery.querySelector('.ppd-product-media');
    return figure ? figure.querySelector('img') : null;
  }

  function moneyNumber(str) {
    var parsed = parseFloat(String(str).replace(/[^0-9.]/g, ''));
    return isNaN(parsed) ? null : parsed;
  }

  function moneySymbol(str) {
    var symbol = String(str).replace(/[\d.,\s]/g, '');
    return symbol ? symbol.charAt(0) : '$';
  }

  function variantPriceMap(select) {
    var map = {};
    Array.prototype.forEach.call(select.options, function (option) {
      var title = (option.textContent || '').split('\u00B7')[0].trim();
      if (title && option.dataset && option.dataset.price) map[title] = option.dataset.price;
    });
    return map;
  }

  /* Position (1-based) of the strap option group, or -1. */
  function strapSegmentIndex(scope) {
    var found = -1;
    scope.querySelectorAll('.variant-field').forEach(function (field) {
      var label = field.querySelector('.variant-field__label');
      var group = field.getAttribute('data-option-group');
      if (label && group && /strap/i.test(label.textContent)) {
        found = parseInt(group, 10);
      }
    });
    return found;
  }

  /* Checked option value per group position, e.g. {1: 'Tarot', 2: 'Silver',
     3: 'Black'}. Read from the chips directly — never by splitting a variant
     title, since values like "Fuschia/Pink Gold Honeycomb" contain slashes. */
  function checkedComboValues(scope) {
    var combo = {};
    var complete = true;
    scope.querySelectorAll('.variant-field').forEach(function (field) {
      var group = parseInt(field.getAttribute('data-option-group'), 10);
      var checked = field.querySelector('.variant-chip[aria-checked="true"]');
      if (isNaN(group) || !checked) {
        complete = false;
        return;
      }
      var value = (checked.getAttribute('data-variant') || '').trim();
      if (!value) {
        complete = false;
        return;
      }
      combo[group] = value;
    });
    return complete ? combo : null;
  }

  function initConfirm(scope) {
    var dialog = scope.querySelector('[data-ppd-config-confirm]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var form = scope.querySelector('form.ppd-product-form');
    var addButton = scope.querySelector('[data-ppd-add-to-cart]');
    if (!form || !addButton) return;

    var img = dialog.querySelector('[data-ppd-config-image]');
    var rowsEl = dialog.querySelector('[data-ppd-config-rows]');
    var priceEl = dialog.querySelector('[data-ppd-config-price]');
    var okButton = dialog.querySelector('[data-ppd-config-ok]');
    var backButton = dialog.querySelector('[data-ppd-config-back]');
    var confirmed = false;

    function populate() {
      var rows = fieldRows(scope);
      if (rowsEl) {
        rowsEl.replaceChildren();
        rows.forEach(function (row) {
          var wrapper = document.createElement('div');
          var term = document.createElement('dt');
          term.textContent = row.name;
          var detail = document.createElement('dd');
          detail.textContent = row.value;
          wrapper.appendChild(term);
          wrapper.appendChild(detail);
          rowsEl.appendChild(wrapper);
        });
      }
      var priceSource = scope.querySelector('[data-ppd-current-price]');
      if (priceEl && priceSource) priceEl.textContent = priceSource.textContent.trim();
      syncPriceBreakdown(scope);
      var source = activeGalleryImage();
      if (img && source && source.currentSrc) {
        img.src = source.currentSrc;
        img.alt = source.alt || '';
        img.removeAttribute('hidden');
      } else if (img) {
        img.removeAttribute('hidden');
      }
    }

    /* Shows "Bag $32.00 / {strap} strap +$7.00" when the selected setup costs
       more than its cheapest same-design strap alternative (usually No strap).
       Otherwise the breakdown stays hidden and the total speaks for itself. */
    function syncPriceBreakdown(scope) {
      var breakdown = dialog.querySelector('[data-ppd-config-breakdown]');
      if (!breakdown) return;
      breakdown.hidden = true;
      var select = scope.querySelector('[data-ppd-variant-select]');
      if (!select || !select.options.length) return;
      var prices = variantPriceMap(select);
      var selectedOption = select.options[select.selectedIndex];
      if (!selectedOption || !selectedOption.dataset) return;
      var selectedPrice = selectedOption.dataset.price || '';
      var selectedNum = moneyNumber(selectedPrice);
      if (selectedNum === null) return;
      var strapPos = strapSegmentIndex(scope);
      var combo = checkedComboValues(scope);
      if (strapPos < 0 || !combo || !combo[strapPos]) return;
      var positions = Object.keys(combo)
        .map(function (key) { return parseInt(key, 10); })
        .sort(function (a, b) { return a - b; });
      var strapField = scope.querySelector('.variant-field[data-option-group="' + strapPos + '"]');
      if (!strapField) return;
      var cheapest = null;
      strapField.querySelectorAll('.variant-chip').forEach(function (chip) {
        var value = (chip.getAttribute('data-variant') || '').trim();
        if (!value || value === combo[strapPos]) return;
        var title = positions
          .map(function (pos) { return pos === strapPos ? value : combo[pos]; })
          .join(' / ');
        var candidate = prices[title];
        var num = moneyNumber(candidate);
        if (num !== null && (cheapest === null || num < cheapest.num)) {
          cheapest = { num: num, str: candidate };
        }
      });
      if (!cheapest || cheapest.num >= selectedNum) return;
      var baseEl = dialog.querySelector('[data-ppd-config-base]');
      var addonLabel = dialog.querySelector('[data-ppd-config-addon-label]');
      var addonEl = dialog.querySelector('[data-ppd-config-addon]');
      if (!baseEl || !addonLabel || !addonEl) return;
      baseEl.textContent = cheapest.str;
      addonLabel.textContent = combo[strapPos] + ' strap';
      addonEl.textContent = '+' + moneySymbol(selectedPrice) + (Math.round((selectedNum - cheapest.num) * 100) / 100).toFixed(2);
      breakdown.hidden = false;
    }

    var submitting = false;
    /* Whichever button actually submitted the form (in-flow or sticky) gets
       focus back on cancel/backdrop-dismiss — not always the in-flow button,
       since a sticky-bar shopper never had focus there to begin with. */
    var returnFocusTarget = addButton;

    function resetSubmissionState() {
      submitting = false;
      if (okButton) {
        okButton.removeAttribute('aria-busy');
        okButton.disabled = false;
      }
    }

    function close(returnFocus) {
      if (dialog.open) dialog.close();
      confirmed = false;
      resetSubmissionState();
      var target = returnFocusTarget || addButton;
      if (returnFocus !== false && target && target.focus) {
        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          target.focus();
        }
      }
    }

    form.addEventListener('submit', function (event) {
      if (confirmed) return;
      event.preventDefault();
      /* Stop the event here: snippets/cart-drawer.liquid replays
         .ppd-product-form submits via fetch at document level without
         checking defaultPrevented, so preventDefault alone still adds to
         the bag behind the preview. Target-phase stopPropagation blocks it
         deterministically; on confirm we return early and the replay runs
         exactly once. */
      if (event.stopPropagation) event.stopPropagation();
      returnFocusTarget = event.submitter || addButton;
      populate();
      if (!dialog.open) dialog.showModal();
      if (okButton) okButton.focus();
    });

    if (okButton) {
      okButton.addEventListener('click', function () {
        if (submitting) return;

        /* Close the preview before starting the real submit. close() clears
           stale state from any earlier attempt; the guard is then held until
           requestSubmit has synchronously dispatched the confirmed submit. */
        close(false);
        submitting = true;
        okButton.setAttribute('aria-busy', 'true');
        okButton.disabled = true;
        confirmed = true;
        try {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        } finally {
          confirmed = false;
          resetSubmissionState();
        }
      });
    }
    if (backButton) backButton.addEventListener('click', function () { close(true); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close(true);
    });
    dialog.addEventListener('close', function () {
      if (!submitting) {
        confirmed = false;
        resetSubmissionState();
      }
    });
  }

  function init() {
    document.querySelectorAll('.ppd-product-details').forEach(initConfirm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
